// import React, { useState } from "react";
// import warningIcon from "../assets/icons/Warning.png";

// const DisclaimerPopup = ({ onAccept }) => {

//   return (
//     <div
//       className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
//       style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 9999 }}
//     >
//       <div
//         className="bg-white rounded-4 shadow-lg p-4"
//         style={{ maxWidth: "768px", width: "90%", position: "relative" }}
//       >
//         <div className="d-flex justify-content-between align-items-start">
//           <div>
//             <h4 className="fw-bold mb-1">Disclaimer</h4>
//             <p className="text-muted mb-4">Please read the disclaimer to proceed</p>
//           </div>
//           <div>
//             <img
//               src={warningIcon}
//               alt="warning"
//               style={{ width: "76px", height: "65px" }}
//             />
//           </div>
//         </div>

//         <div className="text-dark" style={{ fontSize: "15px" }}>
//           <div className="mb-3">
//             <strong>1. Image Ownership:</strong>
//             <p className="mb-0">
//               By uploading any images to this platform, you affirm that you are the rightful owner
//               of the image or have obtained the necessary permissions or licenses to use, modify,
//               and distribute the image. You are responsible for ensuring that you have the legal
//               right to use any images you upload.
//             </p>
//           </div>

//           <div className="mb-3">
//             <strong>2. Prohibited Content:</strong>
//             <ul className="mb-0">
//               <li>Violate any applicable laws, including copyright, trademark, and IP rights.</li>
//               <li>
//                 Contain harmful, illegal, or offensive content (e.g., pornography, hate speech,
//                 violence, or discrimination).
//               </li>
//               <li>Promote, encourage, or engage in illegal activities.</li>
//             </ul>
//           </div>

//           <div className="mb-3">
//             <strong>3. Accuracy and Responsibility:</strong>
//             <p className="mb-0">
//               While efforts are made to provide accurate and high-quality image generation services,
//               the platform does not guarantee the accuracy, legality, or suitability of any images
//               produced or uploaded. Users are solely responsible for the use of the images,
//               including but not limited to verifying their accuracy and ensuring they comply with
//               all applicable laws and regulations.
//             </p>
//           </div>

//           <div>
//             <strong>4. Use of Uploaded Images:</strong>
//             <p className="mb-0">
//               By uploading images to the platform, users grant the platform a limited,
//               non-exclusive, royalty-free license to process, store, and use the images for the
//               purposes of providing services related to image generation, modification, and any
//               other related functionalities.
//             </p>
//           </div>
//         </div>

//         <div className="text-center mt-4">
//           <button
//             className="btn btn-dark px-5 py-2 rounded"
//             // disabled={!isChecked}
//             onClick={onAccept}
//           >
//             I Understand
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DisclaimerPopup;

import React from "react";
import warningIcon from "../assets/UserIcons/Warning.svg";
import "../css/DisclaimerPopup.css"; // 👈 new css file

const DisclaimerPopup = ({ onAccept }) => {
  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-box">
        <div className="disclaimer-header d-flex justify-content-between align-items-start">
          <div>
            <h4 className="fw-bold mb-1">Disclaimer</h4>
            <p className="text-muted mb-4">
              Please read the disclaimer carefully before proceeding.
            </p>
          </div>
          <div className="warning-sec">
            <img src={warningIcon} alt="warning" className="warning-icon" />
          </div>
        </div>

        <div className="disclaimer-content text-dark">
          <div className="mb-3">
            <strong>1. Image Ownership:</strong>
            <p className="mb-0">
              By uploading any image to this platform, you affirm that you are
              the rightful owner of the image or have obtained all necessary
              permissions or licenses to use, modify, or distribute it. You are
              solely responsible for ensuring that you have the legal right to
              upload and use the images.
            </p>
          </div>

          <div className="mb-3">
            <strong>2. Prohibited Content:</strong>
            <p>You may not upload images that:</p>
            <ul className="mb-0">
              <li>
                Violate any applicable laws, including copyright, trademark, or
                other intellectual property rights.
              </li>
              <li>
                Contain harmful, illegal, or offensive material (e.g.,
                pornography, hate speech, violence, discrimination).
              </li>
              <li>Promote, encourage, or depict illegal activities.</li>
            </ul>
          </div>

          <div className="mb-3">
            <strong>3. Accuracy and Responsibility:</strong>
            <p className="mb-0">
              While the platform strives to provide accurate and high-quality
              image-related services, it does not guarantee the accuracy,
              legality, or suitability of any generated or uploaded images.
              Users are fully responsible for how they use the images, including
              verifying accuracy and ensuring compliance with applicable laws
              and regulations.
            </p>
          </div>

          <div>
            <strong>4. Use of Uploaded Images:</strong>
            <p className="mb-0">
              By uploading images, you grant the platform a limited,
              non-exclusive, royalty-free license to process, store, and use the
              images solely for the purpose of providing image generation,
              modification, and other related services.
            </p>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-dark px-5 py-2 rounded" onClick={onAccept}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPopup;
